(() => {
  const root = document.querySelector('[data-mofflue-chatbot]');

  if (!root) {
    return;
  }

  const panel = root.querySelector('[data-chatbot-panel]');
  const toggle = root.querySelector('[data-chatbot-toggle]');
  const close = root.querySelector('[data-chatbot-close]');
  const body = root.querySelector('[data-chatbot-body]');
  const form = root.querySelector('[data-chatbot-form]');
  const input = root.querySelector('[data-chatbot-input]');
  const endpoint = root.dataset.endpoint || '';
  const contactUrl = root.dataset.contactUrl || 'https://mofflue.com/pages/contact';
  const shopDomain = root.dataset.shopDomain || '';
  const productHandle = root.dataset.productHandle || '';
  const productTitle = root.dataset.productTitle || '';
  const sessionId = getSessionId();

  function getSessionId() {
    const key = 'mofflue_chatbot_session_id';
    const existing = window.localStorage.getItem(key);

    if (existing) {
      return existing;
    }

    const generated = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    window.localStorage.setItem(key, generated);
    return generated;
  }

  function setOpen(isOpen) {
    panel.hidden = !isOpen;
    root.classList.toggle('is-open', isOpen);
    toggle.setAttribute('aria-expanded', String(isOpen));

    if (isOpen) {
      input.focus();
      scrollToBottom();
    }
  }

  function scrollToBottom() {
    body.scrollTop = body.scrollHeight;
  }

  function createMessage(text, type) {
    const message = document.createElement('div');
    message.className = `mofflue-chatbot__message mofflue-chatbot__message--${type}`;
    message.textContent = text;
    body.appendChild(message);
    scrollToBottom();
    return message;
  }

  function createStatus(text) {
    const status = document.createElement('div');
    status.className = 'mofflue-chatbot__status';
    status.textContent = text;
    body.appendChild(status);
    scrollToBottom();
    return status;
  }

  function createLineCard() {
    if (!contactUrl) {
      return;
    }

    const card = document.createElement('div');
    card.className = 'mofflue-chatbot__line-card';

    const text = document.createElement('p');
    text.textContent = '注文内容や配送先など、個別確認が必要な内容はお問い合わせフォームで確認します。';

    const link = document.createElement('a');
    link.className = 'mofflue-chatbot__line-button';
    link.href = contactUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = 'お問い合わせフォームを開く';

    card.append(text, link);
    body.appendChild(card);
    scrollToBottom();
  }

  function setBusy(isBusy) {
    input.disabled = isBusy;
    form.querySelector('button[type="submit"]').disabled = isBusy;
  }

  async function ask(question) {
    const trimmed = question.trim();

    if (!trimmed) {
      return;
    }

    if (!endpoint) {
      createMessage(trimmed, 'user');
      createMessage('現在チャット設定が未完了です。確認が必要な内容はお問い合わせフォームよりお問い合わせください。', 'bot');
      createLineCard();
      return;
    }

    createMessage(trimmed, 'user');
    input.value = '';
    setBusy(true);
    const pending = createStatus('回答を確認しています');

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          question: trimmed,
          sessionId,
          pageUrl: window.location.href,
          shopDomain,
          productHandle,
          productTitle,
        }),
      });

      if (!response.ok) {
        throw new Error(`Request failed: ${response.status}`);
      }

      const data = await response.json();
      const answer = data.answer || '確認が必要な内容のため、お問い合わせフォームよりお問い合わせください。';
      pending.remove();
      createMessage(answer, data.type === 'error' ? 'error' : 'bot');

      if (data.needsLine) {
        createLineCard();
      }
    } catch (error) {
      pending.remove();
      createMessage('一時的に回答できません。お手数ですがお問い合わせフォームよりお問い合わせください。', 'error');
      createLineCard();
    } finally {
      setBusy(false);
      input.focus();
    }
  }

  toggle.addEventListener('click', () => setOpen(panel.hidden));
  close.addEventListener('click', () => setOpen(false));

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    ask(input.value);
  });

  root.querySelectorAll('[data-chatbot-prompt]').forEach((button) => {
    button.addEventListener('click', () => ask(button.dataset.chatbotPrompt || ''));
  });

  input.addEventListener('input', () => {
    input.style.height = 'auto';
    input.style.height = `${Math.min(input.scrollHeight, 116)}px`;
  });
})();
